import { useSnackbar } from '@/features/snackbar';
import { NarrativeSetFairValue } from '@/pages/Narrative/components/NarrativeSetFairValue';
import { useCallback } from 'react';
import type { FragmentOf } from '@/utilities/gql';
import type { NARRATIVE_CARD_ACTIONS_FRAGMENT } from './narrativeCardActionsFragment';
import { NarrativeEditButton } from '@/pages/Narrative/components/NarrativeEditButton/NarrativeEditButton';

type Props = {
  narrative: FragmentOf<typeof NARRATIVE_CARD_ACTIONS_FRAGMENT>;
  returnPath?: string;
  onError?: () => void;
};

export const NarrativeCardActions = ({
  narrative,
  returnPath,
  onError,
}: Props) => {
  const { id: narrativeId, isPrimary, companyId, valuation } = narrative;
  const { type: valuationType } = valuation ?? {};
  const { addSnackbar } = useSnackbar();

  const handleError = useCallback(() => {
    if (typeof onError === 'function') {
      onError();
      return;
    }
    addSnackbar({
      message: 'Failed to select fair value. Please try again.',
      type: 'negative',
      lifeTime: 10000,
    });
  }, [addSnackbar, onError]);

  return (
    <div className="grid auto-cols-fr grid-flow-col gap-x1">
      <NarrativeEditButton narrative={narrative} returnPath={returnPath} />
      <NarrativeSetFairValue
        companyId={companyId}
        narrativeId={narrativeId}
        isPrimary={isPrimary}
        onError={handleError}
        valuationType={valuationType}
      />
    </div>
  );
};
